<template>
  <component :is="'script'" type="application/javascript" :src="src"></component>
</template>
<script>
export default {
  props: {
    src: String
  }
}
</script>